(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yd-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initStickyAtc(root) {
      root.querySelectorAll('[data-yd-sticky-atc]').forEach(function (bar) {
        if (bar.__ydInit) return;
        bar.__ydInit = true;

        var form = document.querySelector('.product-single__form');
        var mainBtn = form && form.querySelector('.add-to-cart');
        if (!mainBtn || !('IntersectionObserver' in window)) {
          bar.hidden = true;
          return;
        }

        var btn = bar.querySelector('[data-yd-sticky-btn]');
        var priceOut = bar.querySelector('[data-yd-sticky-price]');
        var meta = form.closest('.product-single__meta') || document;
        var priceSrc = meta.querySelector('[data-product-price]');

        function sync() {
          if (priceSrc && priceOut && priceSrc.textContent.trim()) {
            priceOut.textContent = priceSrc.textContent.trim();
          }
          btn.disabled = mainBtn.disabled;
        }
        sync();
        if (priceSrc) {
          new MutationObserver(sync).observe(priceSrc, { childList: true, characterData: true, subtree: true });
        }
        new MutationObserver(sync).observe(mainBtn, { attributes: true, attributeFilter: ['disabled'] });

        btn.addEventListener('click', function () {
          mainBtn.click();
        });

        new IntersectionObserver(function (entries) {
          var entry = entries[0];
          var scrolledPast = entry.boundingClientRect.bottom < 0;
          bar.classList.toggle('is-visible', !entry.isIntersecting && scrolledPast);
        }).observe(mainBtn);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initStickyAtc(document); });
    } else {
      initStickyAtc(document);
    }
    document.addEventListener('shopify:section:load', function (e) { initStickyAtc(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
